import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { StateTransition } from './state-transition'
import { FieldIssue } from './FieldIssue'
import type { IEntity } from './Entity'
import { Entity } from './Entity'

export interface IBaseEntity extends IEntity {
  code?: string
  name?: string
  remarks?: string
  status?: string
  summary?: string
  stateHistory?: StateTransition[]
}

@ObjectType()
@InputType()
export abstract class BaseEntity extends Entity implements IBaseEntity {
  @Field(() => String, { nullable: true })
  @Prop({ type: String, index: true })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  remarks?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  summary?: string

  @Field(() => [StateTransition])
  @Prop({ type: [StateTransition] })
  stateHistory?: StateTransition[]

  @Field(() => [FieldIssue])
  @Prop({ type: [FieldIssue] })
  fieldIssues?: FieldIssue[]
}
